import React from 'react';
import { Phone, PhoneOff, PhoneIncoming } from 'lucide-react';

/**
 * Full-screen modal shown when an incoming call is ringing on the dialer.
 */
export const IncomingCallModal = ({ callerNumber, onAnswer, onReject }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="incoming-call-modal">
    <div className="bg-[#0d1117] border border-gray-700 rounded-xl p-6 w-80 text-center animate-pulse">
      <div className="w-20 h-20 mx-auto rounded-full bg-green-400/20 flex items-center justify-center mb-4">
        <PhoneIncoming className="w-10 h-10 text-green-400" />
      </div>
      <h3 className="text-white text-lg font-semibold mb-1">Incoming Call</h3>
      <p className="text-teal-400 font-mono mb-6">{callerNumber || 'Unknown'}</p>
      <div className="flex gap-4 justify-center">
        <button
          onClick={onReject}
          className="w-14 h-14 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center transition-colors"
          data-testid="reject-call-btn"
        >
          <PhoneOff className="w-6 h-6 text-white" />
        </button>
        <button
          onClick={onAnswer}
          className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center transition-colors"
          data-testid="answer-call-btn"
        >
          <Phone className="w-6 h-6 text-white" />
        </button>
      </div>
    </div>
  </div>
);
